import { CommonModule, CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { GrossRevenueByAdvisors } from '../../dashboard-interfaces/gross-revenue-by-advisors.interface';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { GrossRevenueByBranches } from '../../dashboard-interfaces/gross-revenue-by-branches.interface';
import { DashboardGrossRevenueService } from '../../dashboard-services/dashboard-gross-revenue/dashboard-gross-revenue.service';
import { HttpStatusCode } from 'axios';
import { GrossRevenueSummary } from '../../dashboard-interfaces/gross-revenue-summary.interface';
import { MatDialog } from '@angular/material/dialog';
import { ViewGrossRevenueBranchAdvisorsDialog } from '../../dashboard-dialogs/view-gross-revenue-branch-advisors/view-gross-revenue-branch-advisors.dialog';
import { ViewGrossRevenueManagerAdvisorsDialog } from '../../dashboard-dialogs/view-gross-revenue-manager-advisors/view-gross-revenue-manager-advisors.dialog';
import { DashboardManagerTeamService } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team.service';
import { Router } from '@angular/router';
import { TabState } from '../../dashboard-interfaces/tab-state.interface';

@Component({
  selector: 'dashboard-gross-revenue',
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    CurrencyPipe,
    ReactiveFormsModule
  ],
  templateUrl: './gross-revenue.component.html',
  styleUrl: './gross-revenue.component.scss'
})
export class GrossRevenueComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private dashboardGrossRevenueService = inject(DashboardGrossRevenueService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamService);
  private matDialog = inject(MatDialog);

  protected currentUserRole: string = '';

  protected grossRevenueSummary: GrossRevenueSummary = {
    grLifeInsurance: 0,
    grInvestments: 0,
    grGeneralInsurance: 0,
    grFeeAndReferral: 0,
    grTotal: 0
  };

  setSprinner = signal(false);

  private grossRevenueByManagerData: GrossRevenueByAdvisors[] = [];
  protected grossRevenueByManagerTableDisplayColumn: string[] = ["repCode", "personName", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
  protected grossRevenueByManagerTableDataSource = new MatTableDataSource<GrossRevenueByAdvisors>();
  isGrossRevenueByManagerTableHidden = signal(false);

  private grossRevenueByAdvisorData: GrossRevenueByAdvisors[] = [];
  protected grossRevenueByAdvisorTableDisplayColumn: string[] = [];
  protected grossRevenueByAdvisorTableDataSource = new MatTableDataSource<GrossRevenueByAdvisors>();
  isGrossRevenueByAdvisorTableHidden = signal(false);

  private grossRevenueByBranchData: GrossRevenueByBranches[] = [];
  protected grossRevenueByBranchTableDisplayColumn: string[] = ["branchName", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
  protected grossRevenueByBranchTableDataSource = new MatTableDataSource<GrossRevenueByBranches>();
  isGrossRevenueByBranchTableHidden = signal(false);

  grossRevenueByManagerTableFilterFc = new FormControl("");
  grossRevenueByAdvisorTableFilterFc = new FormControl("");
  grossRevenueByBranchTableFilterFc = new FormControl("");

  @ViewChild('grossRevenueByManagerTablePaginator')
  grossRevenueByManagerTablePaginator!: MatPaginator;
  @ViewChild('grossRevenueByManagerTableSort')
  grossRevenueByManagerTableSort = new MatSort();

  @ViewChild('grossRevenueByAdvisorTablePaginator')
  grossRevenueByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('grossRevenueByAdvisorTableSort')
  grossRevenueByAdvisorTableSort = new MatSort();

  @ViewChild('grossRevenueByBranchTablePaginator')
  grossRevenueByBranchTablePaginator!: MatPaginator;
  @ViewChild('grossRevenueByBranchTableSort')
  grossRevenueByBranchTableSort = new MatSort();

  @Input('tabState')
  set tabState(state: TabState) {
    this.isCurrentTabActive = state.isActive;
    this.targetYear = state.targetYear;

    this.setAsCurrentTab();
  }

  protected grDashboardDisclaimer: string = "";

  protected isCurrentTabActive: boolean = false;
  protected targetYear: string = "";

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.grossRevenueByAdvisorTableDisplayColumn = ["repCode", "personName", "branch", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
    }
    else {
      this.grossRevenueByAdvisorTableDisplayColumn = ["repCode", "personName", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
    }
  }

  ngAfterViewInit(): void {
    this.grossRevenueByManagerTableDataSource.paginator = this.grossRevenueByManagerTablePaginator;
    this.grossRevenueByManagerTableDataSource.sort = this.grossRevenueByManagerTableSort;
    this.grossRevenueByAdvisorTableDataSource.paginator = this.grossRevenueByAdvisorTablePaginator;
    this.grossRevenueByAdvisorTableDataSource.sort = this.grossRevenueByAdvisorTableSort;
    this.grossRevenueByBranchTableDataSource.paginator = this.grossRevenueByBranchTablePaginator;
    this.grossRevenueByBranchTableDataSource.sort = this.grossRevenueByBranchTableSort;
  }

  async setAsCurrentTab(): Promise<void> {
    this.grossRevenueByAdvisorData = [];
    this.grossRevenueByBranchData = [];
    this.grossRevenueByManagerData = [];

    if (this.isCurrentTabActive) {
      await this.getGrossRevenueData();

      if (this.grossRevenueByAdvisorData.length > 0) {
        // this.grossRevenueByAdvisorTableDataSource.data = this.grossRevenueByAdvisorData;
        this.__applyGrossRevenueByAdvisorDataFilter();
      } else {
        this.isGrossRevenueByAdvisorTableHidden.set(true);
      }

      if (this.grossRevenueByBranchData.length > 0) {
        // this.grossRevenueByBranchTableDataSource.data = this.grossRevenueByBranchData;
        this.__applyGrossRevenueByBranchDataFilter();
      } else {
        this.isGrossRevenueByBranchTableHidden.set(true);
      }

      if (['Director'].includes(this.currentUserRole)) {
        await this.getDashboardDirectorwiseManagers();
        // this.grossRevenueByManagerTableDataSource.data = this.grossRevenueByManagerData;
        this.__applyGrossRevenueByManagerDataFilter();
      } else {
        this.isGrossRevenueByManagerTableHidden.set(true);
      }
    }
  }

  async getGrossRevenueData() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardGrossRevenueService
      .getDashboardGrossRevenue(Number.parseInt(this.targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    // console.log(responseData);

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (this.currentUserRole === 'Corporate') {
        this.mapGrossRevenueSummary(responseData.data.responsedata.corporateapedata[0]);
        this.mapGrossRevenueByBranches(responseData.data.responsedata.branchdata, responseData.data.responsedata.affinitybranch);
      }
      else if (this.currentUserRole === 'BDM') {
        this.mapGrossRevenueSummary(responseData.data.responsedata.bdmapedata[0]);
        this.mapGrossRevenueByBranches(responseData.data.responsedata.bdmbranchreporting, responseData.data.responsedata.affinitybranch);
      }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.mapGrossRevenueByAdvisors(responseData.data.responsedata.apedata);
        this.mapGrossRevenueSummary(responseData.data.responsedata.apesummary[0]);
      }
      else {
        this.mapGrossRevenueSummary(responseData.data.responsedata.apesummary[0]);
      }

      this.setDisclaimers(responseData.data.responsedata.disclamirdata);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  clearManagerSearch() {
    this.grossRevenueByManagerTableFilterFc.setValue('');
    this.isGrossRevenueByManagerTableHidden.set(false);

    this.__applyGrossRevenueByAdvisorDataFilter();
  }

  clearSearch() {
    this.grossRevenueByAdvisorTableFilterFc.setValue('');
    this.isGrossRevenueByAdvisorTableHidden.set(false);

    this.__applyGrossRevenueByAdvisorDataFilter();
  }

  clearBranchSearch() {
    this.grossRevenueByBranchTableFilterFc.setValue('');
    this.isGrossRevenueByBranchTableHidden.set(false);

    this.__applyGrossRevenueByBranchDataFilter();
  }

  private setDisclaimers(disclaimer: any[]) {
    if (this.targetYear == new Date().getFullYear().toString()) {
      this.grDashboardDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "gr_dashboard")[0].dmText.toString();
    } else {
      this.grDashboardDisclaimer = "The Information is based on data as at 31/12/2025.";
    }
  }

  protected mapGrossRevenueSummary(grSummary: any) {
    this.grossRevenueSummary = {
      grLifeInsurance: Number.parseInt(grSummary.grossRevenueTotLifeInsurance.toString()),
      grInvestments: Number.parseInt(grSummary.grossRevenueTotInvestment.toString()),
      grGeneralInsurance: Number.parseInt(grSummary.grossRevenueTotGi.toString()),
      grFeeAndReferral: Number.parseInt(grSummary.grossRevenueTotFeeAndReferral.toString()),
      grTotal: Number.parseInt(grSummary.grossRevenueTot.toString())
    };
  }

  protected mapGrossRevenueByAdvisors(grDataList: any[]) {
    grDataList.forEach((grDataItem) => {
      this.grossRevenueByAdvisorData.push({
        repCode: grDataItem.piasRepCode.toString(),
        personName: grDataItem.agentRealName.toString(),
        branch: grDataItem.branch.toString(),
        lifeInsuranceYtd: grDataItem.grossRevenueTotLifeInsurance.toString(),
        investmentYtd: grDataItem.grossRevenueTotInvestment.toString(),
        generalInsuranceYtd: grDataItem.grossRevenueTotGi.toString(),
        feeAndReferralYtd: grDataItem.grossRevenueTotFeeAndReferral.toString(),
        totalGrossRevenueYtd: grDataItem.grossRevenueTot.toString(),
        userGroup: grDataItem.userGroup.toString()
      });
    });

    this.grossRevenueByAdvisorData = this.grossRevenueByAdvisorData.filter(item => item.userGroup !== 'Affinity');
  }

  protected mapGrossRevenueByBranches(grDataList: any[], affinitybranch: any[]) {
    grDataList.forEach((grDataItem) => {
      this.grossRevenueByBranchData.push({
        branchName: grDataItem.branch.toString(),
        lifeInsuranceYtd: grDataItem.grossRevenueTotLifeInsurance.toString(),
        investmentYtd: grDataItem.grossRevenueTotInvestment.toString(),
        generalInsuranceYtd: grDataItem.grossRevenueTotGi.toString(),
        feeAndReferralYtd: grDataItem.grossRevenueTotFeeAndReferral.toString(),
        totalGrossRevenueYtd: grDataItem.grossRevenueTot.toString()
      });
    });

    this.grossRevenueByBranchData = this.grossRevenueByBranchData.filter(branch => !affinitybranch.find(item => item.branchName === branch.branchName));
  }

  protected __applyGrossRevenueByManagerDataFilter() {
    let filterValue: string = this.grossRevenueByManagerTableFilterFc.value?.toString() || '';

    let tempGrossRevenueByManagerTableData: GrossRevenueByAdvisors[] = [];

    if (filterValue) {
      tempGrossRevenueByManagerTableData = this.grossRevenueByManagerData.filter(grData =>
        grData.repCode.toLowerCase().includes(filterValue.toLowerCase())
        || grData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempGrossRevenueByManagerTableData = this.grossRevenueByManagerData;
    }

    this.grossRevenueByManagerTableDataSource.data = tempGrossRevenueByManagerTableData;
  }

  protected __applyGrossRevenueByAdvisorDataFilter() {
    let filterValue: string = this.grossRevenueByAdvisorTableFilterFc.value?.toString() || '';

    let tempGrossRevenueByAdvisorTableData: GrossRevenueByAdvisors[] = [];

    if (filterValue) {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData.filter(grData =>
        grData.repCode.toLowerCase().includes(filterValue.toLowerCase())
        || grData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData;
    }

    this.grossRevenueByAdvisorTableDataSource.data = tempGrossRevenueByAdvisorTableData;
  }

  protected __applyGrossRevenueByBranchDataFilter() {
    let filterValue: string = this.grossRevenueByBranchTableFilterFc.value?.toString() || '';

    let tempGrossRevenueByBranchTableData: GrossRevenueByBranches[] = [];

    if (filterValue) {
      tempGrossRevenueByBranchTableData = this.grossRevenueByBranchData.filter(grData =>
        grData.branchName.toLowerCase().includes(filterValue.toLowerCase())
      );
    } else {
      tempGrossRevenueByBranchTableData = this.grossRevenueByBranchData;
    }

    this.grossRevenueByBranchTableDataSource.data = tempGrossRevenueByBranchTableData;
  }

  protected async getDashboardDirectorwiseManagers() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardManagerTeamService
      .getDashboardGrossRevenueDirectorwiseManager()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      let managerData: any[] = responseData.data.responsedata;
      managerData.forEach((manager) => {
        this.grossRevenueByManagerData.push({
          repCode: manager.piasRepCode.toString(),
          personName: manager.agentRealName.toString(),
          branch: manager.branch.toString(),
          lifeInsuranceYtd: manager.grossRevenueTotLifeInsurance.toString(),
          investmentYtd: manager.grossRevenueTotInvestment.toString(),
          generalInsuranceYtd: manager.grossRevenueTotGi.toString(),
          feeAndReferralYtd: manager.grossRevenueTotFeeAndReferral.toString(),
          totalGrossRevenueYtd: manager.grossRevenueTot.toString(),
          userGroup: manager.userGroup.toString()
        });
      });

      this.grossRevenueByManagerData = this.grossRevenueByManagerData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected __displayBranchWiseAdvisors(branchName: string) {
    this.matDialog.open(ViewGrossRevenueBranchAdvisorsDialog, {
      data: {
        branchName: branchName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      height: "calc(100vh - 75px)",
      panelClass: 'branch-popup-dialog',
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }

  protected __displayManagerWiseAdvisors(managerRepCode: string, managerName: string) {
    this.matDialog.open(ViewGrossRevenueManagerAdvisorsDialog, {
      data: {
        managerRepCode: managerRepCode,
        managerName: managerName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      panelClass: 'branch-popup-dialog',
      height: "calc(100vh - 75px)",
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }
}
